import { useCallback, useRef, useState } from 'react';

interface UseColumnResizeProps {
  columnId: string;
  currentWidth?: number;
  onWidthChange: (width: number) => void;
}

export const useColumnResize = ({
  columnId,
  currentWidth,
  onWidthChange,
}: UseColumnResizeProps) => {
  const [isDragging, setIsDragging] = useState(false);
  const startWidthRef = useRef<number>(0);
  const startXRef = useRef<number>(0);

  const handleMouseDown = useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault();
      event.stopPropagation();

      setIsDragging(true);
      startXRef.current = event.clientX;

      const header = document.querySelector(
        `[data-column-id="${columnId}"]`
      ) as HTMLElement;
      if (header) {
        startWidthRef.current = currentWidth || header.offsetWidth;
      }

      const handleMouseMove = (e: MouseEvent) => {
        const deltaX = e.clientX - startXRef.current;
        const newWidth = Math.max(50, startWidthRef.current + deltaX);
        onWidthChange(newWidth);
      };

      const handleMouseUp = () => {
        setIsDragging(false);
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };

      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    },
    [columnId, currentWidth, onWidthChange]
  );

  return {
    dragProps: {
      onMouseDown: handleMouseDown,
    },
    isDragging,
  };
};
